// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import './LoaderLogin.css';
// import logo from '../../assets/logo.png';

// const Login = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     phone: '',
//     password: '',
//   });
//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       let data = JSON.stringify({
//         "phoneNo": formData?.phone,
//         "password": formData?.password
//       });

//       let config = {
//         method: 'post',
//         maxBodyLength: Infinity,
//         url: `${process.env.REACT_APP_API_URL}/admin/admin-login`,
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         data: data
//       };

//       setIsLoading(true);
//       axios.request(config)
//         .then((response) => {
//           // console.log(JSON.stringify(response.data));
//           setIsLoading(false);
//           navigate('/dashboard')
//         })
//         .catch((error) => {
//           console.log("error", error);
//           setIsLoading(false);
//           alert(error?.response?.data?.message);
//         });
//     }
//   };

//   const validateForm = () => {
//     let isValid = true;
//     const errors = {};

//     if (!formData.phone.trim()) {
//       errors.phone = 'Phone number is required';
//       isValid = false;
//     }

//     if (!formData.password.trim()) {
//       errors.password = 'Password is required';
//       isValid = false;
//     }

//     setErrors(errors);
//     return isValid;
//   };

//   return (
//     <React.Fragment>
//       <div className="flex items-center min-h-screen p-4 bg-gray-100 lg:justify-center">
//         <div className="flex flex-col overflow-hidden bg-white rounded-md shadow-lg max md:flex-row md:flex-1 lg:max-w-screen-md">
//           <div className="p-4 py-6 text-white bg-[#78c5ee] md:w-80 md:flex-shrink-0 md:flex md:flex-col md:items-center md:justify-evenly">
//             <div className='flex justify-center'>
//               <img
//                 className='w-20 h-auto'
//                 src={logo}
//                 alt="logo" />
//             </div>
//             <div className="my-3 bg-gradient-to-r from-[#f12f2f] to-[#33a7e6] bg-clip-text text-transparent text-4xl font-bold tracking-wider text-center">
//               BBSR Services
//             </div>
//             <p className="mt-6 tracking-wide font-normal text-center text-gray-600 md:mt-0">
//               BBSR Services offers tailored business solutions, including strategic consulting and advanced technology, to optimize operations and drive growth.
//             </p>
//             <p
//               onClick={() => navigate('/')}
//               className="cursor-pointer tracking-wide flex flex-col items-center justify-center mt-10 text-center">
//               Get Started!
//             </p>
//           </div>

//           <div className="p-5 bg-white md:flex-1">
//             <h3 className="my-4 text-2xl font-semibold tracking-wider text-gray-700">
//               Admin Login
//             </h3>

//             <form onSubmit={handleSubmit} className="flex flex-col space-y-5">
//               <div className="flex flex-col space-y-1">
//                 <label htmlFor="phone" className="text-sm font-semibold tracking-wide text-gray-500">
//                   Phone Number
//                 </label>
//                 <input
//                   type="text"
//                   id="phone"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   className={`px-4 py-2 transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 ${errors.phone ? 'border-red-500' : ''}`}
//                 />
//                 {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
//               </div>

//               <div className="flex flex-col space-y-1">
//                 <label htmlFor="password" className="text-sm font-semibold tracking-wide text-gray-500">
//                   Password
//                 </label>

//                 <input
//                   type="password"
//                   id="password"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   className={`px-4 py-2 transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 ${errors.password ? 'border-red-500' : ''}`}
//                 />
//                 {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
//               </div>

//               <div>
//                 <button
//                   type="submit"
//                   className="tracking-wider flex justify-center items-center w-full px-4 py-2 text-lg font-semibold text-white transition-colors duration-300 bg-blue-500 rounded-md shadow hover:bg-blue-600 focus:outline-none focus:ring-blue-200 focus:ring-4"
//                 >
//                   {
//                     isLoading
//                       ?
//                       <div className="load-spinner"></div>
//                       :
//                       'Log In'
//                   }
//                 </button>
//               </div>

//               <div
//                 onClick={() => navigate('/forgot-password')}
//                 className="text-sm text-center cursor-pointer tracking-wide Password text-blue-600 hover:underline focus:text-blue-800">
//                 Forgot Password?
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </React.Fragment>
//   )
// }

// export default Login;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import { FaLock, FaUserShield, FaEye, FaEyeSlash } from "react-icons/fa";
import bgimg from "../../assets/login/loginbg.jpg";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  // Load saved credentials on component mount
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/admin/login`,
        { email, password }
      );
      toast.success("Login Successful!");
      
      // Store token and credentials based on remember me preference
      if (rememberMe) {
        localStorage.setItem("adminToken", data.token);
        localStorage.setItem("rememberedEmail", email);
        localStorage.setItem("rememberedPassword", password);
      } else {
        sessionStorage.setItem("adminToken", data.token);
        // Clear saved credentials if remember me is unchecked
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("rememberedPassword");
      }
      
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Invalid credentials");
      toast.error(err.response?.data?.message || "Login failed");
    }
  };

  // Handle remember me checkbox change
  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
    
    // If unchecked, clear saved credentials
    if (!e.target.checked) {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgimg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-indigo-500 to-purple-600 bg-blend-overlay px-4"
    >
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md"
      >
        {/* Header */}
        <div className="flex flex-col items-center mb-6">
          <div className="bg-blue-100 p-4 rounded-full mb-3">
            <FaUserShield className="text-blue-600 text-3xl" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800">Admin Login</h2>
          <p className="text-gray-500 text-sm mt-1">
            Secure access to your dashboard
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="bg-red-100 text-red-700 text-sm p-2 rounded mb-3 text-center">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-gray-600 font-medium mb-1">
              Email Address
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              required
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">
              Password
            </label>
            <div className="relative">
              <FaLock className="absolute top-3.5 left-3 text-gray-400" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-lg p-3 pl-10 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-3.5 right-3 text-gray-400 hover:text-gray-600 transition"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* Remember Me Checkbox */}
          <div className="flex items-center">
            <input
              type="checkbox"
              id="rememberMe"
              checked={rememberMe}
              onChange={handleRememberMeChange}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
            />
            <label
              htmlFor="rememberMe"
              className="ml-2 text-sm text-gray-600 cursor-pointer select-none"
            >
              Remember me
            </label>
          </div>

          <motion.button
            whileTap={{ scale: 0.95 }}
            type="submit"
            className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold py-3 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 shadow-md"
          >
            Sign In
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
};

export default Login;
